"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressDots = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme");

var _Box = require("../Box");

var _Clickable = require("../Clickable");

var _VisuallyHidden = require("../VisuallyHidden");

var _excluded = ["activeIndex", "amount", "variant", "onClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VARIANTS = {
  dot: {
    width: "5px",
    height: "5px",
    borderRadius: "50%"
  },
  dash: {
    height: "1px",
    flex: 1
  }
};

/**
 * Renders an `amount` of dots and announces progress when updated
 */
var ProgressDots = function ProgressDots(_ref) {
  var activeIndex = _ref.activeIndex,
      amount = _ref.amount,
      _ref$variant = _ref.variant,
      indicatorVariant = _ref$variant === void 0 ? "dot" : _ref$variant,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  var bgColor = (0, _Theme.useThemeConfig)({
    v2: "black10",
    v3: "black30"
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    role: "presentation",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    my: 0.5
  }, rest), Array.from(Array(amount)).map(function (_, i) {
    var indicator = /*#__PURE__*/_react.default.createElement(Indicator, {
      key: i,
      variant: indicatorVariant,
      bg: i === activeIndex ? "black100" : bgColor,
      mx: 0.5
    });

    var handleClick = function handleClick() {
      return onClick && onClick(i);
    };

    if (onClick) {
      return /*#__PURE__*/_react.default.createElement(_Clickable.Clickable, {
        key: i,
        display: "block",
        position: "relative",
        width: indicatorVariant === "dash" ? "100%" : "auto",
        onClick: handleClick
      }, /*#__PURE__*/_react.default.createElement(_Box.Box, {
        position: "absolute",
        top: -10,
        bottom: -10,
        left: 0,
        width: "100%"
      }), indicator);
    }

    return indicator;
  })), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, {
    "aria-live": "polite",
    "aria-atomic": "true"
  }, "Page ", activeIndex + 1, " of ", amount));
};

exports.ProgressDots = ProgressDots;
var Indicator = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "ProgressDots__Indicator",
  componentId: "sc-1ri84c3-0"
})(["", " transition:background-color 250ms;"], (0, _styledSystem.variant)({
  variants: VARIANTS
}));
Indicator.displayName = "Indicator";
//# sourceMappingURL=ProgressDots.js.map